import React, { useState } from "react";
import { ArrowRight } from "lucide-react";

const About = () => {
	const [activeTab, setActiveTab] = useState("Early Life");

	const tabs = [
		{
			id: "Early Life",
			title: "Early Life",
			content: {
				title: "Growing Up with Technology",
				description:
					"From a young age, I was fascinated by how things worked - taking apart computers and exploring the endless possibilities of technology. My fascination with technology combined with my eargerness to learn naturally meant a caeer in learning technology was inevitable.",
			},
		},
		{
			id: "Professional Life",
			title: "Professional Life",
			content: {
				title: "Building Digital Experiences",
				description:
					"With over 10 years of experience in creating and project managing digital solutions, I've worked with companies across various industries to create innovative solutions, e-learning systems, and interactive applications. My focus is on combining technical excellence with thoughtful design to deliver products that users love.",
			},
		},
		{
			id: "Personal Life",
			title: "Personal Life",
			content: {
				title: "Beyond the Code",
				description:
					"When I'm not coding, you'll find me exploring new technologies, reading about design trends, or working on personal projects. I believe in continuous learning and staying curious about the world around us. I'm also a fitness enthusiast who enjoys everything from weightlifting to rowing.",
			},
		},
		{
			id: "Philosophy",
			title: "Philosophy",
			content: {
				title: "Technology with Purpose",
				description:
					"I believe technology should serve people, not the other way around. Every project I work on is guided by the principle of creating meaningful, accessible, and impactful learning experiences. My goal is to bridge the gap between complex technical solutions and intuitive educational tools that actually enhance how people learn and grow.",
			},
		},
	];

	return (
		<section className="min-h-screen bg-black py-12 sm:py-16 md:py-20">
			<div className="max-w-7xl mx-auto px-4 sm:px-6">
				{/* Mobile Navigation Link */}
				<div className="md:hidden mb-6">
					<a
						href="/projects"
						className="inline-flex items-center text-gray-300 hover:text-white transition-colors duration-200 font-medium text-sm"
					>
						<span className="mr-2">←</span>
						Projects
					</a>
				</div>

				<div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
					{/* Left Column - Image */}
					<div className="relative">
						<div className="relative w-full max-w-md mx-auto">
							{/* Background gradient */}
							<div className="absolute inset-0 bg-gradient-to-br from-orange-700/30 to-orange-500/30 rounded-3xl blur-xl"></div>

							{/* Image container */}
							<div className="relative bg-gradient-to-br from-orange-700/20 to-orange-500/20 rounded-3xl p-8 border border-orange-500/20">
								<img
									src="/JamesDixon.png"
									alt="James Dixon"
									className="w-full h-auto rounded-2xl object-cover"
								/>
							</div>
						</div>
					</div>

					{/* Right Column - Content */}
					<div className="space-y-6 sm:space-y-8">
						{/* Header */}
						<div className="space-y-3 sm:space-y-4">
							<div className="text-xs sm:text-sm text-orange-400 font-medium tracking-wide uppercase">
								About Me
							</div>
							<h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white">
								James Dixon
							</h1>
							<p className="text-lg sm:text-xl text-gray-300 leading-relaxed max-w-2xl">
								Hello, I'm James, a passionate developer and digital learning
								creator. I specialize in building modern digital solutions that
								combine technical excellence with thoughtful design.
							</p>
						</div>

						{/* Navigation Tabs */}
						<div className="space-y-4 sm:space-y-6">
							<div className="flex flex-wrap gap-2">
								{tabs.map((tab) => (
									<button
										key={tab.id}
										onClick={() => setActiveTab(tab.id)}
										className={`flex items-center space-x-1 sm:space-x-2 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-all duration-200 ${
											activeTab === tab.id
												? "bg-gradient-to-r from-orange-700 to-orange-500 text-white"
												: "bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white"
										}`}
									>
										<ArrowRight className="w-3 h-3" />
										<span>{tab.title}</span>
									</button>
								))}
							</div>

							{/* Tab Content */}
							<div className="bg-gray-900/30 rounded-2xl p-4 sm:p-6 md:p-8 border border-gray-800">
								{tabs.map(
									(tab) =>
										activeTab === tab.id && (
											<div key={tab.id} className="space-y-3 sm:space-y-4">
												<h3 className="text-xl sm:text-2xl font-bold text-white">
													{tab.content.title}
												</h3>
												<p className="text-gray-300 leading-relaxed text-base sm:text-lg">
													{tab.content.description}
												</p>
											</div>
										),
								)}
							</div>
						</div>

						{/* Skills/Highlights */}
						<div className="grid grid-cols-2 gap-3 sm:gap-4">
							<div className="bg-gray-800/50 p-4 sm:p-6 rounded-xl">
								<div className="text-xl sm:text-2xl font-bold text-orange-400 mb-1 sm:mb-2">
									10+
								</div>
								<div className="text-gray-300 text-xs sm:text-sm">
									Years Experience
								</div>
							</div>
							<div className="bg-gray-800/50 p-4 sm:p-6 rounded-xl">
								<div className="text-xl sm:text-2xl font-bold text-orange-400 mb-1 sm:mb-2">
									50+
								</div>
								<div className="text-gray-300 text-xs sm:text-sm">
									Projects Completed
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
